import { Skeleton, Typography, Paper, Grid } from '@mui/material';

import { i18n } from '../../translate/i18n';

const ContactDrawerSkeleton = ({ classes }) => {
  return (
    <div style={classes.content}>
      <Paper square variant='outlined' style={classes.contactHeader}>
        <Grid container>
          <Grid size='auto'>
            <Skeleton
              animation='wave'
              variant='circle'
              width={160}
              height={160}
              style={classes.contactAvatar}
            />
          </Grid>
          <Grid size='auto'>
            <Skeleton animation='wave' height={25} width={90} />
            <Skeleton animation='wave' height={25} width={80} />
            <Skeleton animation='wave' height={25} width={80} />
          </Grid>
        </Grid>
      </Paper>
      <Paper square style={classes.contactDetails}>
        <Typography variant='subtitle1'>
          {i18n.t('contactDrawer.extraInfo')}
        </Typography>
        <Paper square variant='outlined' style={classes.contactExtraInfo}>
          <Skeleton animation='wave' height={20} width={60} />
          <Skeleton animation='wave' height={20} width={160} />
        </Paper>
        <Paper square variant='outlined' style={classes.contactExtraInfo}>
          <Skeleton animation='wave' height={20} width={60} />
          <Skeleton animation='wave' height={20} width={160} />
        </Paper>
        <Paper square variant='outlined' style={classes.contactExtraInfo}>
          <Skeleton animation='wave' height={20} width={60} />
          <Skeleton animation='wave' height={20} width={160} />
        </Paper>
      </Paper>
    </div>
  );
};

export default ContactDrawerSkeleton;
